import { ControlSchemaType } from '../ControlTypes';

export const draft: ControlSchemaType = {
  generalInformation: {
    name: {},
    code: {},
    sponsorId: {},
    dataStorageLocationId: {},
    description: {},
    iagStudyEmail: {},
    dashboardUrl: {},
    ctGovLink: {},
    eudraCt: {},
    phase: {},
    therapeuticArea: {},
    disease: {},
    drugMolecule: {},
    dicomViewerVersion: {},
    startDate: {},
    endDate: {},
    firstPatientVisit: {},
    lastPatientVisit: {},
    siteHypothesis: {},
    patientHypothesis: {},
    visitHypothesis: {},
  },
  imagingLabels: {
    addLabel: {},
    deleteLabel: {},
  },
  visits: {
    addCohort: {},
    deleteCohort: {},
    editCohort: {},
    addVisit: {},
    deleteVisit: {},
    editVisit: {},
  },
  team: {
    deleteTeamMember: {},
  },
  forms: {
    assignForm: {},
    editForm: {},
    deleteForm: {},
  },
};
